import { CandidateItemModel, CandidateItemSetModel } from "models";
import React, { ChangeEvent } from "react";
import { Utils } from "utils";
import CandidateItemListItemElement from "./CandidateItemLIstItemElement";

type PROPS = {
  item: CandidateItemSetModel;
  selectedList: CandidateItemSetModel[];
  onChangeSelectedState: (item: CandidateItemSetModel, value: boolean) => void;
  onDelete: (target: CandidateItemModel) => void;
};

const CandidateItemListItem: React.FC<PROPS> = (props) => {
  const item = props.item;
  const LIMIT_CANDIDATE_ITEM = 14;

  const [selected, setSelected] = React.useState(false);

  /** 個別見積もりの商品を含むかどうか */
  const hasDisCretionaryPrice = () => {
    for (const _ of props.item.candidate_item_list) {
      if (_.is_discretionary_price) {
        return true;
      }
    }
    return false;
  };

  const onChangeCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChangeSelectedState(props.item, e.target.checked);
  };

  const calcTotal = (target: CandidateItemSetModel) => {
    let sum = 0;
    for (const item of target.candidate_item_list) {
      sum += item.sale_price * item.quantity;
    }
    return Math.floor(sum);
  };

  const [total, setTotal] = React.useState(calcTotal(item));

  React.useEffect(() => {
    const selected = props.selectedList.find((item) => item.corp_id === props.item.corp_id);
    setSelected(!!selected);
  }, [props.selectedList, props.item]);

  React.useEffect(() => {
    setTotal(calcTotal(item));
  }, [item]);

  return (
    <div>
      <div className="flex justify-between border-b border-b-black">
        <label>
          <input
            className="cursor-pointer"
            style={{zoom: "1.5"}}
            type="checkbox"
            checked={selected}
            disabled={props.selectedList.length > LIMIT_CANDIDATE_ITEM && !selected}
            onChange={onChangeCheckbox}
          />
          <span className="ml-4 font-bold text-2xl">{item.corp_name}</span>
        </label>
      </div>
      <div className="flex items-end gap-4 p-4 border-b border-b-black">
        <table className="w-full table-fixed">
          <thead>
            <tr className="border-b border-b-gray-400">
              <th className="w-40"></th>
              <th>商品名</th>
              <th>数量</th>
              <th className="w-40">価格(税抜)</th>
              <th className="w-12"></th>
            </tr>
          </thead>
          <tbody>
            {item.candidate_item_list.map((v, index2) => (
              <CandidateItemListItemElement
                key={index2}
                item={v}
                update={() => setTotal(calcTotal(item))}
                onDelete={props.onDelete}
              />
            ))}
            <tr>
              <td></td>
              <td></td>
              <td className="text-center font-bold">合計(税抜)</td>
              {hasDisCretionaryPrice() ? (
                <td className="text-center">-</td>
              ) : (
                <td className="text-center">
                  <span className="font-bold">{Utils.addTotalComma(total)}</span>
                  <span>円(税抜)</span>
                </td>
              )}
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CandidateItemListItem;
